module.exports = __webpack_public_path__ + "img/2024517-icon3-active.f8c5674.svg";